import { cx } from '../lib/cx';

export interface MessageBubbleProps {
  body: string;
  timeLabel: string;
  from: 'me' | 'them';
  authorName?: string;
  className?: string;
}

export function MessageBubble({ body, timeLabel, from, authorName, className }: MessageBubbleProps) {
  const mine = from === 'me';
  return (
    <div className={cx('flex flex-col', mine ? 'items-end' : 'items-start', className)}>
      {authorName && !mine && <span className="mb-1 text-[11px] text-ink-muted">{authorName}</span>}
      <div
        className={cx(
          'max-w-[85%] px-4 py-3 text-[14.5px] leading-relaxed sm:max-w-[70%]',
          mine
            ? 'rounded-[14px_14px_4px_14px] bg-accent-dark text-surface'
            : 'rounded-[14px_14px_14px_4px] border border-line-subtle bg-surface text-ink shadow-card',
        )}
      >
        {body}
      </div>
      <span className="mt-1 text-[11px] text-ink-muted">{timeLabel}</span>
    </div>
  );
}
